import React from 'react';
import Icon from '../../Icon';
import { S } from './styles';

const ClearAllFilters = ({ clearAllFilters }) => (
  <S.ClearAllFiltersContainer
    onClick={() => clearAllFilters()}
  >
    <span>Remover todos os filtros</span>
    <div>
      <Icon name="close" />
    </div>
  </S.ClearAllFiltersContainer>
);

export default ClearAllFilters;
